var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5045 15.8404C10.3503 15.8404 8.60176 14.1197 8.60176 12C8.60176 9.88027 10.3503 8.15965 12.5045 8.15965C14.6587 8.15965 16.4073 9.88027 16.4073 12C16.4073 14.1197 14.6587 15.8404 12.5045 15.8404ZM12.5045 9.49002C11.0984 9.49002 9.95375 10.6164 9.95375 12C9.95375 13.3836 11.0984 14.51 12.5045 14.51C13.9106 14.51 15.0553 13.3836 15.0553 12C15.0553 10.6164 13.9106 9.49002 12.5045 9.49002Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5045 20C9.11551 20 5.9158 18.0488 3.71656 14.6608C2.76115 13.1973 2.76115 10.8115 3.71656 9.33925C5.92481 5.95122 9.12453 4 12.5045 4C15.8845 4 19.0842 5.95122 21.2834 9.33925C22.2389 10.8027 22.2389 13.1885 21.2834 14.6608C19.0842 18.0488 15.8845 20 12.5045 20ZM12.5045 5.33038C9.59322 5.33038 6.80811 7.051 4.86124 10.0576C4.18525 11.0953 4.18525 12.9047 4.86124 13.9423C6.80811 16.949 9.59322 18.6696 12.5045 18.6696C15.4158 18.6696 18.2009 16.949 20.1478 13.9423C20.8238 12.9047 20.8238 11.0953 20.1478 10.0576C18.2009 7.051 15.4158 5.33038 12.5045 5.33038Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6b972c9deda5c1c770f4c320071f6bf1.svg";
export { ForwardRef as ReactComponent };